import { useLocale, useTranslations } from 'next-intl'
import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui'

import { useToggleRoomList } from '../lib/sidebar'

const Sidebar = ({ children }: PropsWithChildren) => {
  const locale = useLocale()

  const t = useTranslations('map')

  const isKorean = locale === 'ko'

  const { isOpen, toggle } = useToggleRoomList()

  const handleRoomListOpenButtonClick = () => {
    toggle()
  }

  return (
    <div
      className={cn(
        'z-sidebar relative bg-white drop-shadow-[0px_0px_4px_rgba(0,0,0,0.45)]',
        !isOpen && '-translate-x-full',
      )}
    >
      {isOpen && children}
      <button
        className={cn(
          'absolute top-10 left-full flex h-[50px] w-8 cursor-pointer items-center justify-end gap-1 rounded-r-lg bg-white px-1',
          !isOpen && (isKorean ? 'w-[106px]' : 'w-[120px]'),
        )}
        onClick={handleRoomListOpenButtonClick}
        aria-label={isOpen ? t('list.button.close') : t('list.button.open')}
      >
        {(() => {
          if (isOpen) {
            return (
              <Icon
                name="arrow-left"
                size={24}
                strokeWidth={1.5}
                className="text-black"
              />
            )
          }

          return (
            <>
              <span className="typo-label2 font-medium text-black">
                {t('list.button.open')}
              </span>
              <Icon
                name="arrow-right"
                size={24}
                strokeWidth={1.5}
                className="text-black"
              />
            </>
          )
        })()}
      </button>
    </div>
  )
}

export default Sidebar
